module.exports = __webpack_public_path__ + "img/7C7C71_353630_ADAFAF_444444-256px.b41f0629.png";